// extracted by mini-css-extract-plugin
export default {"container":"RightPaneHeader__container___mjj71","leftContainer":"RightPaneHeader__leftContainer___LySx0"};